import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DisplayType } from 'src/app/models/enums/display-type';
import { WebSocketNotificationMessage } from 'src/app/models/ws/websocket-notification-message';

/**
 * Service utilisé pour afficher les notifications à l'utilisateur.
 */
@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    /**
     * Constructeur
     */
    constructor(protected toastr: ToastrService) {}

    /**
     * Affiche une notification d'erreur.
     * @param title : Titre de la notification.
     * @param message: Message de la notification.
     * @param options: Options de personnalisation de la notification.
     */
    public displayError(title: string, message: string, options?: any) {
        this.toastr.error(message, title, options);
    }

    /**
     * Affiche une notification d'information.
     * @param title : Titre de la notification.
     * @param message: Message de la notification.
     * @param options: Options de personnalisation de la notification.
     */
    public displayInfo(title: string, message: string, options?: any) {
        this.toastr.info(message, title, options);
    }

    /**
     * Affiche une notification de succès.
     * @param title : Titre de la notification.
     * @param message: Message de la notification.
     * @param options: Options de personnalisation de la notification.
     */
    public displaySuccess(title: string, message: string, options?: any) {
        this.toastr.success(message, title, options);
    }

    /**
     * Affiche une notification d'avertissement.
     * @param title : Titre de la notification.
     * @param message: Message de la notification.
     * @param options: Options de personnalisation de la notification.
     */
    public displayWarning(title: string, message: string, options?: any) {
        this.toastr.warning(message, title, options);
    }

    /**
     * Affiche une notification
     * @param notification : Information de la notification
     */
    public display(notification: WebSocketNotificationMessage) {
        switch (notification.displayType) {
            case DisplayType.Error:
                this.displayError(notification.message, '');
                break;
            case DisplayType.Information:
                this.displayInfo(notification.message, '');
                break;
            case DisplayType.Success:
                this.displaySuccess(notification.message, '');
                break;
            case DisplayType.Warning:
                this.displayWarning(notification.message, '');
                break;
        }
    }
}
